/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiCustomListsDtoCreateCustomListDto,
  WebApiCustomListsDtoCustomListDto,
  WebApiCustomListsDtoUpdateCustomListDto,
} from '../models';
import {
    WebApiCustomListsDtoCreateCustomListDtoFromJSON,
    WebApiCustomListsDtoCreateCustomListDtoToJSON,
    WebApiCustomListsDtoCustomListDtoFromJSON,
    WebApiCustomListsDtoCustomListDtoToJSON,
    WebApiCustomListsDtoUpdateCustomListDtoFromJSON,
    WebApiCustomListsDtoUpdateCustomListDtoToJSON,
} from '../models';

export interface ApiCustomListGenerateExcelGetRequest {
    id?: number;
}

export interface ApiCustomListIdDeleteRequest {
    id: number;
}

export interface ApiCustomListIdGetRequest {
    id: number;
}

export interface ApiCustomListIdPutRequest {
    id: number;
    webApiCustomListsDtoUpdateCustomListDto?: WebApiCustomListsDtoUpdateCustomListDto;
}

export interface ApiCustomListPostRequest {
    webApiCustomListsDtoCreateCustomListDto?: WebApiCustomListsDtoCreateCustomListDto;
}

/**
 * 
 */
export class CustomListApi extends runtime.BaseAPI {

    /**
     * 
     */
    async apiCustomListGenerateExcelGetRaw(requestParameters: ApiCustomListGenerateExcelGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomList/generateExcel`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiCustomListGenerateExcelGet(requestParameters: ApiCustomListGenerateExcelGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiCustomListGenerateExcelGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiCustomListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiCustomListsDtoCustomListDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomList`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiCustomListsDtoCustomListDtoFromJSON));
    }

    /**
     */
    async apiCustomListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiCustomListsDtoCustomListDto>> {
        const response = await this.apiCustomListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCustomListIdDeleteRaw(requestParameters: ApiCustomListIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiCustomListIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomList/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiCustomListIdDelete(requestParameters: ApiCustomListIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiCustomListIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiCustomListIdGetRaw(requestParameters: ApiCustomListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiCustomListIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomList/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiCustomListIdGet(requestParameters: ApiCustomListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListDto> {
        const response = await this.apiCustomListIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCustomListIdPutRaw(requestParameters: ApiCustomListIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiCustomListIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomList/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoUpdateCustomListDtoToJSON(requestParameters.webApiCustomListsDtoUpdateCustomListDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiCustomListIdPut(requestParameters: ApiCustomListIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListDto> {
        const response = await this.apiCustomListIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCustomListPostRaw(requestParameters: ApiCustomListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoCreateCustomListDtoToJSON(requestParameters.webApiCustomListsDtoCreateCustomListDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiCustomListPost(requestParameters: ApiCustomListPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListDto> {
        const response = await this.apiCustomListPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
